import Swiper, { Autoplay, Pagination } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'swiper/scss/autoplay';
import 'swiper/scss/effect-fade';
if (customElements.get('component-cities') === undefined) {
    class Cards extends HTMLElement {
        constructor() {
            super();
            this.swiper = this.querySelector('.swiper');
            this.carousel = null;
            this.style.display = 'block';
            this.style.position = 'relative';
        }
        static get observedAttributes() {
            return [];
        }
        attributeChangedCallback(attr, oldVal, newVal) {
            if (oldVal !== newVal) {
                this[attr] = newVal;
            }
        }
        connectedCallback() {
            this.setCarousel();
        }
        setCarousel() {
            this.carousel = new Swiper(this.swiper, {
                modules: [Autoplay, Pagination],
                slidesPerView: 3.3,
                spaceBetween: 32,
                loop: true,
                speed: 700,
                freeMode: true,
                pagination: {
                    el: this.swiper.querySelector('.swiper-pagination'),
                    type: "progressbar",
                },
                autoplay: {
                    delay: 5500,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.5,
                    },
                    768: {
                        slidesPerView: 1.7,
                    },
                    1024: {
                        slidesPerView: 2.5,
                    },
                    1200: {
                        slidesPerView: 3.3,
                    },
                },
            });
        }
    }
    customElements.define('component-cities', Cards);
}
